<template>
  <v-card flat>
    <v-toolbar dark color="primary" rounded="0" elevation="0">
      <v-toolbar-title v-if="!editingAward" color="primary">
        <Typography as="p" variant="body-1" class="mb-0">Add a new Award</Typography>
      </v-toolbar-title>
      <v-toolbar-title v-else color="primary">
        <Typography as="p" variant="body-1" class="mb-0">Update an Award</Typography>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-if="awardForm.page == 0">
        <v-btn dark text @click="resetForm">
          <span>Cancel</span>
        </v-btn>
        <v-btn
          color="white"
          text
          @click="createNewAward"
          :disabled="!awardForm.valid"
          v-if="!editingAward"
        >
          Create Award
        </v-btn>
        <v-btn
          color="white"
          text
          @click="updateAward"
          :disabled="!awardForm.valid || award.clientId === 0"
          v-else
        >
          Update Award
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-divider />

    <v-divider />
    <v-container v-if="awardForm.page == 0" class="py-6 px-4">
      <v-card-text class="pa-0">
        <v-form ref="awardForm" v-model="awardForm.valid">
          <v-autocomplete
            class="pa-1 full-width"
            :items="clients"
            item-text="formattedName"
            item-value="clientId"
            label="Client*"
            v-model="award.clientId"
            :disabled="editingAward"
            v-if="userProfile.clientId == 1 && !clientId"
          ></v-autocomplete>
          <!-- <v-text-field
            class="pa-1"
            v-model="award.awardName"
            :rules="[(v) => !!v || 'Name is required']"
            label="Name*"
            required
          ></v-text-field> -->
          <v-text-field
            class="pb-0 mb-1"
            v-model="award.awardDisplayName"
            :rules="[
              (v) => !!v || 'Award name is required',
              (v) => !!(v && v.length < 255) || 'Award name should be shorter',
            ]"
            label="Name*"
            outlined
          ></v-text-field>
          <v-text-field
            class="pb-0 mb-1"
            v-model="award.awardDescription"
            label="Description"
            :rules="[(v) => !!(!v || v.length < 255) || 'Description should be shorter']"
            outlined
          ></v-text-field>
          <!-- <v-text-field
            class="pa-1"
            v-model="award.awardValue"
            type="number"
            :rules="[
              (v) => !!v || 'Award value is required',
              (v) => !!(v && v > 0) || 'Award value must be a positive number',
              (v) =>
                !!(v && !v.toString().includes('.')) ||
                'Award value must be a whole number',
            ]"
            label="Award value*"
          ></v-text-field> -->
          <v-row cols="2" class="ma-0 pa-0 form-row">
            <v-text-field
              class="pb-0 mb-1"
              v-model="award.unitSingular"
              :rules="[
                (v) => !!v || 'Unit singular is required',
                (v) => !!(v && v.length < 40) || 'Less than 40 characters',
              ]"
              label="Unit Singular*"
              outlined
            ></v-text-field>
            <v-text-field
              class="pb-0 mb-1"
              v-model="award.unitSingularAbbreviation"
              label="Unit Singular Abbreviation"
              outlined
              :rules="[(v) => !v || v.length <= 10 || '10 characters or less']"
            ></v-text-field>
          </v-row>
          <v-row cols="2" class="ma-0 pa-0 form-row">
            <v-text-field
              class="pb-0 mb-1"
              v-model="award.unitPlural"
              :rules="[
                (v) => !!v || 'Unit plural is required',
                (v) => !!(v && v.length < 40) || 'Less than 40 characters',
              ]"
              label="Unit Plural*"
              outlined
            ></v-text-field>
            <v-text-field
              class="pb-0 mb-1"
              v-model="award.unitPluralAbbreviation"
              label="Unit Plural Abbreviation"
              outlined
              :rules="[(v) => !v || v.length <= 10 || '10 characters or less']"
            ></v-text-field>
          </v-row>
          <v-row class="ma-0 pa-0" v-if="isOne10PointsEnabled(award.clientId)">
            <Typography variant="subtitle-1" class="mb-4">Point Value Type</Typography>
            <Typography variant="body-1" as="p" class="text-left"
              >Choose whether these points carry a cash value or are for recognition
              only.</Typography
            >
            <v-radio-group v-model="award.cashValuePoints" mandatory class="mt-0">
              <v-radio
                label="Cash Value points (convertible to $)"
                :value="true"
                class="mt-0"
              ></v-radio>
              <v-radio label="Recognition Points Only (no monetary value)" :value="false"></v-radio>
            </v-radio-group>
          </v-row>
          <!-- <v-select
            class="pa-1"
            :items="categories"
            item-text="category"
            item-value="id"
            label="Category*"
            v-model="award.category"
            :rules="[v => !!v || 'Category is required']"
          ></v-select> -->
          <!-- <v-menu
            v-model="awardForm.menuExpirationDate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <div class="v-flex flex-row">
                <v-text-field
                  v-if="!awardForm.expDateCheckBox"
                  v-model="award.expirationDate"
                  label="Award Expiration Date*"
                  :rules="[(v) => !!v || 'Expiration date is required']"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
                <v-checkbox
                  class="checkBoxes mt-0 pt-0"
                  v-model="awardForm.expDateCheckBox"
                  @change="checkBoxUpdated()"
                  label="No end date"
                >
                </v-checkbox>
              </div>
            </template>
            <v-date-picker
              v-model="award.expirationDate"
              @input="awardForm.menuExpirationDate = false"
              :disabled="awardForm.expDateCheckBox"
            ></v-date-picker>
          </v-menu> -->
        </v-form>
      </v-card-text>
      <v-card-actions class="px-0">
        <v-tooltip
          top
          :disabled="!disableDelete"
          v-if="editingAward && permissions.includes('awards:delete:award')"
        >
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <Button
                class="mr-4"
                v-if="editingAward && permissions.includes('awards:delete:award')"
                color="red"
                text
                @click="deleteAward"
                :disabled="disableDelete"
              >
                Delete
              </Button>
            </div>
          </template>
          <span>A budget is currently tied to this award</span>
        </v-tooltip>
        <Button text class="mr-4" @click="resetForm"> Cancel </Button>
        <Button @click="createNewAward" :disabled="!awardForm.valid" v-if="!editingAward">
          Create Award
        </Button>
        <Button @click="updateAward" :disabled="!awardForm.valid || award.clientId === 0" v-else>
          Update
        </Button>
      </v-card-actions>
    </v-container>
    <!-- Dialog used for displaying loading message. -->
    <LoadingDialog
      :showDialog="showLoadingDialog"
      :header="loadingHeaderMessage"
      :line1="loadingMessageLine1"
      :line2="loadingMessageLine2"
    ></LoadingDialog>
  </v-card>
</template>

<script>
import LoadingDialog from "@/components/loadingDialog.vue";
import { mapState } from "vuex";
import BudgetService from "@/services/BudgetService.js";
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
import isOne10PointsEnabled from "@/mixins/one10Points/isOne10PointsEnabled";
export default {
  name: "AwardCreatorWidget",
  components: {
    LoadingDialog,
    Typography,
    Button,
  },
  mixins: [isOne10PointsEnabled],
  props: {
    editingAward: Boolean,
    editAwardObject: Object,
    budgets: Array,
    clientId: Number,
    source: String,
  },
  data() {
    return {
      showLoadingDialog: false,
      loadingHeaderMessage: null,
      loadingMessageLine1: null,
      loadingMessageLine2: null,
      loadingAwardTable: true,
      awardTableSearch: null,
      selected: [],
      awards: [],
      parentBudgets: [],
      type: [
        { label: "Client", value: "CLIENT" },
        { label: "Platform", value: "PLATFORM" },
        { label: "Certification", value: "CERTIFICATION" },
      ],
      context: [
        { label: "Learning", value: "LEARNING" },
        { label: "Programs", value: "PROGRAM" },
        { label: "Other", value: "OTHER" },
      ],
      categories: ["Cash", "Travel", "Physical Award", "Other"],
      awardForm: {
        menuStartDate: false,
        // menuExpirationDate: false,
        // expDateCheckBox: true,
        valid: false,
        page: 0,
      },
      award: {
        clientId: null,
        awardId: null,
        // awardName: null,
        awardDisplayName: null,
        awardDescription: null,
        // awardValue: null,
        unitSingular: null,
        unitSingularAbbreviation: null,
        unitPlural: null,
        unitPluralAbbreviation: null,
        category: null,
        cashValuePoints: false,
        // expirationDate: null,
      },
    };
  },
  mounted() {},
  created() {
    console.log("get awards");
    if (this.editingAward) {
      // We only care about budgets if we're editing an award so we can block them from deleting
      this.award = JSON.parse(JSON.stringify(this.editAwardObject));
      // Ensure cashValuePoints has a default value if undefined
      if (this.award.cashValuePoints === undefined) {
        this.award.cashValuePoints = false;
      }

      this.getParentBudgets();
    } else if (this.clientId) {
      console.log("Setting clientId to predefined");
      this.award.clientId = this.clientId;
    } else {
      console.log("Setting clientId to user clientId");
      this.award.clientId = this.userProfile.clientId;
    }
  },
  beforeUnmount() {
    //Clears the search in case they go to a page without search
    // this.$store.dispatch("setSearchArray", []);
    // this.unwatch();
  },
  methods: {
    async createNewAward() {
      this.showLoadingDialog = true;
      this.loadingHeaderMessage = "Creating a new award";
      this.loadingMessageLine1 = "This should just take a minute.";
      this.loadingMessageLine2 = "";

      //set up award object
      var returnObj = {
        awardName: this.award.awardDisplayName,
        awardDisplayName: this.award.awardDisplayName,
        awardDescription: this.award.awardDescription,
        // awardValue: this.award.awardValue,
        unitSingular: this.award.unitSingular,
        unitSingularAbbreviation: this.award.unitSingularAbbreviation,
        unitPlural: this.award.unitPlural,
        unitPluralAbbreviation: this.award.unitPluralAbbreviation,
        category: this.award.category,
        cashValuePoints: this.award.cashValuePoints,
        // expirationDate: this.award.expirationDate,
        // supplementAwardInfo: {
        //   physicalItems: this.award.physicalAwards
        // }
      };
      if (this.award.clientId !== null) {
        returnObj.clientId = this.award.clientId;
      }

      if (this.source) returnObj.source = this.source;

      console.log("Award create: ", returnObj);
      BudgetService.createAward(returnObj)
        .then(async (response) => {
          console.log(response);

          if (response && response.awardId) {
            console.log("award created");
            this.showLoadingDialog = false;
            this.resetForm();
            this.$emit("refreshAwards", response.awardId);
          } else {
            console.log("Error creating award");
            this.showLoadingDialog = false;
            this.resetForm();
            this.$emit("refreshAwards", null);
          }
        })
        .catch((error) => {
          console.log(error);
          this.showLoadingDialog = false;
        });
    },
    async updateAward() {
      this.showLoadingDialog = true;
      this.loadingHeaderMessage = "Updating award";
      this.loadingMessageLine1 = "This should just take a minute.";
      this.loadingMessageLine2 = "";

      //set up the updated award object
      var returnObj = {
        awardId: this.award.awardId,
        awardName: this.award.awardDisplayName,
        awardDisplayName: this.award.awardDisplayName,
        awardDescription: this.award.awardDescription,
        // awardValue: this.award.awardValue,
        unitSingular: this.award.unitSingular,
        unitSingularAbbreviation: this.award.unitSingularAbbreviation,
        unitPlural: this.award.unitPlural,
        unitPluralAbbreviation: this.award.unitPluralAbbreviation,
        category: this.award.category,
        cashValuePoints: this.award.cashValuePoints,
        // expirationDate: this.award.expirationDate,
        // supplementAwardInfo: {
        //  physicalItems: this.award.physicalAwards
        // }
      };

      if (this.award.clientId !== null) {
        returnObj.clientId = this.award.clientId;
      }

      console.log("Award update, ", returnObj);
      BudgetService.updateAward(this.award.awardId, returnObj)
        .then(async (response) => {
          console.log(response);

          if (response) {
            console.log("Award updated");
            console.log(this.editAwardObject);
            this.showLoadingDialog = false;
            this.resetForm();
            this.$emit("refreshAwards", null);
          } else {
            console.log("Error updating award");
          }
        })
        .catch((error) => {
          console.log(error);
          this.showLoadingDialog = false;
        });
    },
    deleteAward() {
      this.showLoadingDialog = true;
      this.loadingHeaderMessage = "Deleting award";
      this.loadingMessageLine1 = "This should just take a minute.";
      this.loadingMessageLine2 = "";
      BudgetService.deleteAward(this.award.awardId)
        .then((response) => {
          console.log(response);
          this.showLoadingDialog = false;
          if (response) {
            console.log("Award deleted");
            this.resetForm();
            this.$emit("refreshAwards", null);
          } else {
            console.log("Error updating award");
          }
        })
        .catch((error) => {
          console.log(error);
          this.showLoadingDialog = false;
        });
    },
    async getParentBudgets() {
      // If parent budgets weren't passed in from the parent, then we fetch them here
      if (!this.budgets || this.budgets.length == 0) {
        var response = await BudgetService.getParentBudgets({
          awardId: this.award.awardId,
          lite: 1,
        });
        console.log("Got parent budgets");
        response = response.filter((x) => x.status != "Deleted");
        this.parentBudgets = response;
      } else {
        this.parentBudgets = this.budgets;
      }
      //  Used for the award creator component
    },
    resetForm() {
      console.log("closing award form");
      this.$emit("close");
    },
    // checkBoxUpdated() {
    //   if (this.awardForm.expDateCheckBox) {
    //     this.award.expirationDate = null;
    //   }
    // },
  },
  computed: {
    ...mapState(["clients", "userProfile", "permissions", "featureFlags"]),
    disableDelete() {
      if (!this.editingAward) return false;
      var currentAward = this.award.awardId;
      var index = this.parentBudgets.findIndex(
        (x) =>
          x.awardId === currentAward &&
          (this.clientId ? this.clientId : this.userProfile.clientId) == x.clientId
      );
      if (index !== -1 || this.award.clientId === 0) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.outlined {
  border: 1px solid;
  /* border-left: 4px; */
  border-width: 1px 1px 0px 1px;
  border-color: var(--v-grey-base);
}
.outlined-bottom {
  border-width: 1px 1px 1px 1px;
}

.form-row {
  column-gap: 24px;
}
</style>
